import ManageStock from './ManageStock'
import ManageExcess from './ManageExcess'
import ManageRestock from './ManageRestock'
import ManageTabs from './ManageTabs'

function ManageInventory() {
  const labels = ['Stock', 'Excess Report', 'Restock Report']

  const panels = [<ManageStock />, <ManageExcess />, <ManageRestock />]

  return <ManageTabs title="Inventory" labels={labels} panels={panels} />
}

export default ManageInventory
